export default {
  methods: {
    padTime(value) {
      if (value === null || value === undefined || value === "") return "";
      return String(value).padStart(2, "0");
    },
    isValidHour(value) {
      if (value === null || value === undefined || value === "") return false;
      const normalized = String(value).trim();
      if (!/^\d{1,2}$/.test(normalized)) return false;
      const parsed = Number(normalized);
      return Number.isInteger(parsed) && parsed >= 0 && parsed <= 23;
    },
    isValidMinute(value) {
      if (value === null || value === undefined || value === "") return false;
      const normalized = String(value).trim();
      if (!/^\d{1,2}$/.test(normalized)) return false;
      const parsed = Number(normalized);
      return Number.isInteger(parsed) && parsed >= 0 && parsed <= 59;
    },
    isValidTimePair(hours, minutes) {
      return this.isValidHour(hours) && this.isValidMinute(minutes);
    },
    parseTimeValue(value) {
      if (!value || typeof value !== "string") return null;
      const [hours, minutes] = value.split(":");
      if (!this.isValidTimePair(hours, minutes)) return null;
      return {
        hours: this.padTime(hours),
        minutes: this.padTime(minutes),
      };
    },
  },
};